import React, { useEffect, useState } from "react";
import { Close, Menu } from "@mui/icons-material";
import styled from "@emotion/styled";
import ErrorFallbackComponent from "./ErrorFallbackComponent";
import NavItemComponent from "./NavItemComponent";
import { useAppSelector } from "../../store/hooks";
import {
  findTemplateByStoredReference,
  getTemplateLinkedComponent,
  getTemplateSourceComponent,
} from "./utilities/templateHelpers";
import { defaultComponents } from "./interfaces/DefaultComponents";
import "./Default.css";
import {
  getComponentFromStructureMap,
  getComponentIdentityKey,
  getRelationChildKey,
} from "./utilities/componentIdentity";

const Div = styled("div")(
  null,
  (props) =>
    function (props: any) {
      return { ...props["data-style"] };
    }
);

export default function MobileNavigation({
  id,
  attributes,
  childElements,
  childWebpageComponentRelations,
}: any) {
  const structure = useAppSelector((state) => state.builder.structure);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const templates = useAppSelector((state) => state.builder.templates);
  const components = useAppSelector(
    (state) => state.builder.structure.components
  );

  const component = useAppSelector((state) =>
    getComponentFromStructureMap(state.builder.structure.components, id)
  ) as any;

  const navAttributes = component?.attributes ?? attributes;

  const mobileMenuTemplate = findTemplateByStoredReference(
    templates,
    navAttributes?.mobileMenuTemplateId
  );

  let mobileMenuTemplateComponent;

  if (mobileMenuTemplate) {
    mobileMenuTemplateComponent =
      getTemplateLinkedComponent(components, mobileMenuTemplate) ??
      getTemplateSourceComponent(mobileMenuTemplate as any);
  }

  const ComponentToRender =
    defaultComponents[mobileMenuTemplateComponent?.type];

  useEffect(() => {
    if (!component?.attributes) {
      return;
    }
    const header = document.querySelector(
      ".builder-component__header"
    ) as HTMLElement;

    const parentResolved =
      component.parent_id != null
        ? getComponentFromStructureMap(components, component.parent_id)
        : undefined;
    const parentDomId = parentResolved
      ? getComponentIdentityKey(parentResolved)
      : component.parent_id != null
        ? String(component.parent_id)
        : "";
    const containerElement = parentDomId
      ? document.getElementById(parentDomId)
      : null;

    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.overflowX = "hidden";

      if (header) {
        header.classList.add("remove__backdrop");
      }

      if (containerElement) {
        containerElement.style.position = "unset";
      }
    } else {
      document.body.style.overflow = "auto";
      document.body.style.overflowX = "hidden";
      if (containerElement) {
        containerElement.style.position = "relative";
      }

      if (header) {
        header.classList.remove("remove__backdrop");
      }
    }
  }, [mobileMenuOpen, component, components]);

  if (!navAttributes) {
    return <></>;
  }

  return (
    <>
      <style>
        {`
     .mobilemenu-open-template .container {
      margin-left: ${
        navAttributes.templateAlignContent === "left" ? "0" : "auto"
      };
      margin-right: ${
        navAttributes.templateAlignContent === "right" ? "0" : "auto"
      };
     }

     .accordion-content .container.g-0 {
      margin-left: 0;
     }


     .mobilemenu-open-template .container .row {
      min-height: 100%;
      max-height: 100dvh;
      height: 100dvh;
      overflow: scroll;
     }

     .mobilemenu-open-template .container .row .accordion-content .container .row {
      height: auto;
      scrollbar-width: none;
      overflow: hidden;
     }
 


    `}
      </style>

      <div
        className="mobilemenutriggers"
        style={{ display: "flex", alignItems: "center", overflow: "hidden" }}
      >
        {mobileMenuOpen &&
          (!navAttributes.mobileMenuTemplateId ||
            navAttributes.mobileMenuTemplateId === null) && (
            <div
              className="mobile-menu"
              style={{
                marginRight: "10px",
                position: "absolute",
                top: "0",
                left: "0",
                background: "#fff",
                width: "100%",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                padding: "60px 30px",
                fontSize: "24px !important",
                zIndex: "999",
              }}
            >
              <ul className="mobile-menu-unordered-list">
                {(childWebpageComponentRelations ?? []).map(
                  (componentRelation) => {
                  const childKey =
                    getRelationChildKey(componentRelation) ??
                    String(componentRelation.child_id);
                  const childComponent = getComponentFromStructureMap(
                    structure.components,
                    childKey
                  );
                    if (childComponent && childComponent.type !== "editor") {
                      return (
                        <ErrorFallbackComponent
                          key={
                            getComponentIdentityKey(childComponent) +
                            "_errorBoundary_"
                          }
                        >
                          <NavItemComponent
                            {...(childComponent as any)}
                            key={getComponentIdentityKey(childComponent)}
                            isMobile={true}
                            mobileMenuOpen={mobileMenuOpen}
                            setMobileMenuOpen={setMobileMenuOpen}
                          />
                        </ErrorFallbackComponent>
                      );
                    }
                  }
                )}
              </ul>
              <Close
                onClick={() => setMobileMenuOpen(false)}
                style={{
                  fontSize: "24px",
                  color: "#000",
                  marginTop: "4px",
                  cursor: "pointer",
                  position: "absolute",
                  right: "40px",
                  top: "40px",
                }}
              />
            </div>
          )}

        {mobileMenuTemplateComponent && mobileMenuOpen && (
          <div
            style={{
              display: "flex",
              height: "fit-content",
              minHeight: "100dvh",
              backgroundColor: navAttributes.templateBackgroundcolor
                ? navAttributes.templateBackgroundcolor
                : "#fff",
              maxHeight: "100dvh",
              position: "absolute",
              top: "0",
              left: "0",
              width: "100%",
              zIndex: 99,
            }}
            className={`mobilemenu-open-template ${
              mobileMenuOpen && mobileMenuTemplateComponent
                ? "mobilemenu-open-template-open"
                : "mobilemenu-open-template-closed"
            }`}
            onClick={(e) => {
              if (
                (e.target as HTMLElement).classList.contains(
                  "mobilemenu-open-template-open"
                )
              ) {
                setMobileMenuOpen(false);
              }
            }}
          >
            <ComponentToRender
              {...mobileMenuTemplateComponent}
              key={getComponentIdentityKey(mobileMenuTemplateComponent)}
            />

            <Close
              onClick={() => {
                setMobileMenuOpen(false);
              }}
              style={{
                fontSize: "24px",
                color: "#000",
                marginTop: "4px",
                cursor: "pointer",
                position: "absolute",
                right: "40px",
                top: "20px",
                zIndex: 9999999999,
              }}
            />
          </div>
        )}
        {mobileMenuOpen === false ? (
          <Menu
            onClick={() => setMobileMenuOpen(true)}
            style={{
              color: navAttributes.mobileNavColor
                ? navAttributes.mobileNavColor
                : "#000",
              marginTop: "4px",
              cursor: "pointer",
              zIndex: 999999,
              fontSize: navAttributes.hamburgerSize,
            }}
          />
        ) : (
          <Close
            onClick={() => setMobileMenuOpen(false)}
            style={{
              color: navAttributes.mobileNavColor
                ? navAttributes.mobileNavColor
                : "#fff",
              marginTop: "4px",
              cursor: "pointer",
            }}
          />
        )}
      </div>
    </>
  );
}
